import { ChainId } from '../constants'

export interface StoredCurrency {
  chainId: ChainId
  name: string
  symbol: string
  decimals: number
}

export class Currency {
  constructor(readonly chainId: ChainId, readonly name: string, readonly symbol: string, readonly decimals: number) {}

  isNative() {
    return ['ETH', 'KETH', 'GETH'].includes(this.symbol)
  }

  serialize(): StoredCurrency {
    return {
      chainId: this.chainId,
      name: this.name,
      symbol: this.symbol,
      decimals: this.decimals,
    }
  }

  static deserialize({ chainId, name, symbol, decimals }: StoredCurrency) {
    return new Currency(chainId, name, symbol, decimals)
  }
}

export class Token extends Currency {
  constructor(
    readonly chainId: ChainId,
    readonly address: string,
    readonly name: string,
    readonly symbol: string,
    readonly decimals: number
  ) {
    super(chainId, name, symbol, decimals)
  }
}
